import LinkWrapper from "./LinkWrapper";

export default LinkWrapper;
